import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';

const LoaderContainer = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: 'rgba(150, 150, 150, 0.8)',
  backdropFilter: 'blur(1px)',
  zIndex: 99,
}));

export default function Loader({textrecieved}) {
  const [text, setText] = useState(textrecieved);

  useEffect(() => {
    setTimeout(() => {
      setText("Please Wait Operation in progress...");
    }, 4000);
  }, []);

  return (
    <>
      <LoaderContainer>
        <div style={{ display: "flex", flexDirection:"column", width: "60vw", height: "40vh", alignItems: "center"}}>
          <div style={{paddingTop:"7rem"}}>
          <CircularProgress />
          </div>
          <div style={{color: "var(--white)",fontSize:'2rem'}}>{text}</div>
        </div>
      </LoaderContainer>
    </>
  );
};